import React from 'react';
import { motion } from 'framer-motion';
import { Card } from '../components/ui/Card';
import { Badge } from '../components/ui/Badge';
import SafeIcon from '../common/SafeIcon';
import { FiBox, FiClock, FiMapPin } from 'react-icons/fi';
import { DELIVERIES } from '../data/mockData';

export const Deliveries = () => {
  return (
    <motion.div initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} className="space-y-6">
       <div className="flex justify-between items-center">
        <div>
          <h1 className="text-2xl font-bold text-slate-100 tracking-tight">Material Logic</h1>
          <p className="text-slate-400 text-sm mt-1 font-mono">Incoming logistics and supply chain status.</p>
        </div>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        {DELIVERIES.map((delivery) => (
          <Card key={delivery.id} className="relative overflow-hidden">
             {delivery.status === 'Delayed' && (
               <div className="absolute top-0 left-0 w-full h-1 bg-yellow-500"></div>
             )}
             {delivery.status === 'En Route' && (
               <div className="absolute top-0 left-0 w-full h-1 bg-cyan-500"></div>
             )}
            <div className="flex justify-between items-start mb-4">
              <Badge variant={delivery.status === 'Delayed' ? 'yellow' : delivery.status === 'En Route' ? 'cyan' : 'default'}>
                {delivery.status}
              </Badge>
              <span className="text-xs font-mono text-slate-500">{delivery.id}</span>
            </div>
            
            <h3 className="text-lg font-bold text-slate-200 mb-1">{delivery.material}</h3>
            <p className="text-sm text-slate-400 mb-6 flex items-center gap-2">
              <SafeIcon icon={FiBox} className="text-slate-500"/> {delivery.supplier}
            </p>

            <div className="space-y-2 text-sm">
              <div className="flex items-center gap-3 text-slate-300">
                <SafeIcon icon={FiClock} className="text-cyan-500" />
                <span className="font-mono">{delivery.eta}</span>
              </div>
              <div className="flex items-center gap-3 text-slate-400">
                <SafeIcon icon={FiMapPin} className="text-slate-500" />
                <span>{delivery.site}</span>
              </div>
            </div>
          </Card>
        ))}
      </div>
    </motion.div>
  );
};